module.exports = __webpack_public_path__ + "img/border10.11eab360.png";